// Common Backend And Frontend Constants

const BackendFrontend = {
  // Inventory Equipment Form Register Constants
  OPTIONS: "options",
  OPTIONS_VALUES: "options-values",
  DECIMAL_NUMBER: "decimal-number",
  IMAGES: "images",
  NUMBER: "number",
  TEXT: "text",
  SEARCH: "search",
  DATE: "date",
  CERTIFICATE_TYPE: "certificateType",
  VALIDITY_DATE: "validity-date",
  QR_CODE: "qr-code",
  RADIO: "radio",
  TAX_ID_NUMBERS: "taxIdNumbers",

  // Personnel "Project" filter: lists the users who are not assigned to any project
  NOT_ASSIGNED_PROJECT: "notAssigned",
};

export default BackendFrontend;
